import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import _ from 'lodash';
import React from 'react';

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    tableRow: {
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
});
const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.grey[50],
        color: theme.palette.grey[900],
        border: "none",
        fontFamily: 'NHaasGroteskDSPro-65Md',
        fontSize: 14,
        verticalAlign: "middle",
        padding: theme.spacing(2),
        height: "auto",
        whiteSpace: " nowrap",
    },

}))(TableCell);

class HeaderFailed extends React.Component {
    constructor(props) {
        super(props);
        this._id = _.uniqueId('model_row');
    }
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }
    render() {
        return (
            <TableRow key={this._id}>
                <CustomTableCell>Serial Number</CustomTableCell>
                <CustomTableCell>Model</CustomTableCell>
              
                <CustomTableCell>Date</CustomTableCell>
                <CustomTableCell>Requested By</CustomTableCell>
                <CustomTableCell>Request Type</CustomTableCell>
                <CustomTableCell>Requested Brand</CustomTableCell>
                <CustomTableCell>Requested Model</CustomTableCell>
                <CustomTableCell>Industry Partner</CustomTableCell>
                <CustomTableCell>Location</CustomTableCell>
               
            </TableRow>
        );
    }
}
export default withStyles(styles)(HeaderFailed);
